import { render, staticRenderFns } from "./terceros.vue?vue&type=template&id=cba430fc&"
import script from "./terceros.vue?vue&type=script&lang=js&"
export * from "./terceros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports